import { colorCreatorWithRange } from '../../utils/colorUtils';
import StyleFactory, { getNumberFromFeatureProps, getLineValueFromFeature, getAreaLabelFromFeature, getAreaValueFromFeature } from '../../StyleFactory';
const labels = ['5+', '3-5', '1-3', '0.5-1', '<0.5'];
export const themeSelector = (value, theme) => ({
  color: colorCreatorWithRange(theme.color, value, theme.min, theme.max)
});

const getLabelByValue = value => {
  let index = Math.round(value);
  index = Math.max(index, 0);
  index = Math.min(index, labels.length);
  return labels[index];
};

const defaultLabelSelector = feature => {
  const value = getNumberFromFeatureProps()(feature);
  return getLabelByValue(value);
};

const areaLabelSelector = feature => {
  const value = getAreaLabelFromFeature(feature);
  return getLabelByValue(value);
};

const gridView = StyleFactory.createStyle({
  valueSelector: getNumberFromFeatureProps(),
  themeSelector,
  labelSelector: defaultLabelSelector
});
const lineView = StyleFactory.createStyle({
  valueSelector: getLineValueFromFeature,
  themeSelector,
  labelSelector: defaultLabelSelector
});
export default {
  grid: gridView,
  line: lineView,
  area: StyleFactory.createStyleWithLabel({
    labelSelector: areaLabelSelector,
    valueSelector: getAreaValueFromFeature,
    themeSelector
  })
};